import json2csv from 'json2csv';
import FileSaver from 'file-saver';

export default {
  download(fields, data) {
    const output = json2csv({
      data,
      fields
    });

    const blob = new Blob([output], {
      type: 'text/csv;charset=utf-8'
    });

    FileSaver.saveAs(blob, 'data.csv');
  },

  extractValueOf(item) {
    let result = item;
    const keys = this.value.split('.');

    keys.forEach((key, i) => {
      if (result) {
        result = result[keys[i]];
      }
    });

    return result;
  }
};



// WEBPACK FOOTER //
// ./src/shared/pager/csv-exporter.js